import { html } from '@crossiety/lit-components/components/application_element/element.js';

import '../components/fa_icon/element.js';

import Icon from '@crossiety/lit-components/components/icon/element.js';

Icon.prototype.renderIcon = function renderIcon() {
  return html`<fa-icon .name=${this.name}></fa-icon>`;
};
